import { SearchTexts } from '@/types';
import { jsonClient } from '../config';

// --- VersionMinecraft ---

export function getMcVersions() {
  return jsonClient.get<SearchTexts.McVersion[]>('/search-content/mc-versions/')
}

export function createMcVersion(version: string) {
  return jsonClient.post<SearchTexts.McVersion>('/search-content/mc-versions/', { version })
}

export function updateMcVersion(id: number, version: string) {
  return jsonClient.patch<SearchTexts.McVersion>(`/search-content/mc-versions/${id}/`, { version })
}

export function deleteMcVersion(id: number) {
  return jsonClient.delete<any>(`/search-content/mc-versions/${id}/`)
}

// --- VersionDescriptionHtml ---

export function getDescriptions() {
  return jsonClient.get<SearchTexts.DescriptionHtml[]>('/search-content/descriptions/')
}

export function createDescription(data: {
  title: string; description: string; t_header: string; t_text: string; b_header: string; b_text: string;
}) {
  return jsonClient.post<SearchTexts.DescriptionHtml>('/search-content/descriptions/', data)
}

export function updateDescription(id: number, data: {
  title?: string; description?: string; t_header?: string; t_text?: string; b_header?: string; b_text?: string;
}) {
  return jsonClient.patch<SearchTexts.DescriptionHtml>(`/search-content/descriptions/${id}/`, data)
}

export function deleteDescription(id: number) {
  return jsonClient.delete<any>(`/search-content/descriptions/${id}/`)
}

// --- VersionDescription (join table) ---

export function getVersionDescriptions() {
  return jsonClient.get<SearchTexts.VersionDescriptionItem[]>('/search-content/version-descriptions/')
}

export function createVersionDescription(version: number, types: string, description: number) {
  return jsonClient.post<SearchTexts.VersionDescriptionItem>('/search-content/version-descriptions/', { version, types, description })
}

export function updateVersionDescription(id: number, version?: number, types?: string, description?: number) {
  return jsonClient.patch<SearchTexts.VersionDescriptionItem>(`/search-content/version-descriptions/${id}/`, { version, types, description })
}

export function deleteVersionDescription(id: number) {
  return jsonClient.delete<any>(`/search-content/version-descriptions/${id}/`)
}
